<template>
  <b-container
    ref="navmain"
    fluid
    class="app-nav shadow_1 h-100 px-0 text-font-grey bg-white"
  >
    <transition-group name="slideside" mode="out-in">
      <b-row align-v="center" class="px-0" key="logo-row">
        <b-col
          v-if="$root.isMobile"
          class="text-right"
          cols="3"
          lg="2"
          key="padspace"
        >
        </b-col>
        <b-col class="px-1 py-2 mt-2 text-left" cols="6" lg="12" sm="12">
          <router-link :to="{ name: 'AdminDashboard' }" class="">
            <img
              v-if="menuIsCompact && !$root.isMobile"
              :src="require(`@/assets/${$root.scope}/dot-logo.svg`)"
              :alt="$t('NavigationAdmin.logo_alt')"
              class="app-nav__logo app-nav__logo--compact px-lg-2"
              style="max-width: 75px"
              key="icon_logo"
            />
            <img class="app-nav__logo"
              v-else
              :src="require(`@/assets/${$root.scope}/logo.svg`)"
              :alt="$t('NavigationAdmin.logo_alt')"
              key="full_logo"
              :style="
                $root.isCollapsed ? 'max-width: 80px' : 'max-width: 100px'
              "
            />
          </router-link>
        </b-col>
        <b-col
          key="mobile_ham"
          v-if="$root.isMobile"
          class="text-right"
          cols="3"
          lg="2"
          @click="menuVisible = !menuVisible"
          role="button"
          tabindex="0"
          :aria-label="$t('NavigationAdmin.toggle_menu')"
          :aria-expanded="menuVisible.toString()"
          @keydown.enter.prevent="menuVisible = !menuVisible"
          @keydown.space.prevent="menuVisible = !menuVisible"
        >
          <b-icon font-scale="1.3" icon="filter-left" aria-hidden="true"></b-icon>
        </b-col>
      </b-row>
      <b-row cols="1" class="px-0" key="menu-row" v-if="menuVisible">
        <b-col
          class="px-2 px-md-4 px-lg-4 pb-xl-2 pb-1 pt-0 text-left app-nav__toggle"
          v-if="!$root.isMobile"
          key="desk_ham"
        >
          <p class="pb_15 nav__item bg-white">
            <span
              class="d-flex align-items-center pl-1 py-1 general_border_3 point pt-3"
              role="button"
              tabindex="0"
              :aria-label="$t('NavigationAdmin.toggle_menu_size')"
              @click="handleMenuSize"
              @keydown.enter.prevent="handleMenuSize"
              @keydown.space.prevent="handleMenuSize"
            >
              <b-icon font-scale="1.7" icon="filter-left" aria-hidden="true"></b-icon>
              <span class="mb-0 ml-2"></span>
              <span v-if="!menuIsCompact" class="text-font-light-grey"
                >{{ $t("NavigationAdmin.menu") }}</span
              >
            </span>
          </p>
        </b-col>
        <b-col class="px-2 px-md-4 px-lg-4 pb-xl-2 pb-1 pt-0 text-left">
          <!-- <p class="text-font-light-grey">
            <span :class="menuIsCompact ? 'text-white' : ''">APP</span>
          </p> -->
          <!-- <p>
            <router-link
              class="my-3 mx-auto text-font-grey"
              :to="positions[clientiSet.position_ref]"
            >
              <b-icon font-scale="1.3" :icon="clientiSet.logo"></b-icon>
              <span class="mb-0 ml-2">{{ clientiSet.name }}</span>
            </router-link>
          </p> -->
          <p class="pb_15 nav__item bg-white">
            <router-link
              class="d-flex align-items-center pl-1 py-1 general_border_3"
              :class="
                this.$route.name === 'AdminDashboard'
                  ? 'router-link-exact-active'
                  : ''
              "
              :to="{ name: 'AdminDashboard' }"
            >
              <b-icon font-scale="1.3" icon="house-door"></b-icon>
              <span class="mb-0 ml-2">{{ $t("NavigationAdmin.dashboard") }}</span>
            </router-link>
          </p>
        </b-col>
        <b-col class="px-2 px-md-4 px-lg-4 pb-xl-2 pb-1 pt-0 text-left">
          <!-- <p class="text-font-light-grey">
            <span :class="menuIsCompact ? 'invisible' : ''">STRUMENTI</span>
          </p> -->
          <p
            class="pb_15 nav__item"
            :class="service.submenu ? 'bg-mdm-light-grey' : 'bg-white'"
            v-for="(service, ind) in activeServices"
            :key="ind"
          >
            <template v-if="service.submenu">
              <span
                :key="'sub-m-' + service.routeName"
                class="d-flex align-items-center pl-1 py-1 general_border_3 point"
                role="button"
                tabindex="0"
                :aria-expanded="service.submenuVisible ? 'true' : 'false'"
                :aria-label="$t('NavigationAdmin.toggle_submenu', { name: service.name })"
                :class="
                  $route.name === service.routeName
                    ? 'router-link-exact-active'
                    : ''
                "
                @click="toggleSubmenu(service)"
                @keydown.enter.prevent="toggleSubmenu(service)"
                @keydown.space.prevent="toggleSubmenu(service)"
              >
                <b-icon font-scale="1.3" :icon="service.logo" aria-hidden="true"></b-icon>
                <span class="mb-0 ml-2 text-capitalize">{{
                  service.name
                }}</span>
                <b-icon
                  font-scale="1"
                  :icon="service.submenuVisible ? 'chevron-up' : 'chevron-down'"
                  class="mr-1 ml-auto"
                ></b-icon>
              </span>
              <b-collapse
                class="mt-1"
                :id="service.name + '-sub'"
                v-model="service.submenuVisible"
              >
                <p
                  v-for="rt in service.subroutes"
                  :key="'sub-' + rt.name"
                  class="mb-1"
                >
                  <router-link
                    class="d-flex align-items-center pl-1 py-1 general_border_3 align-items-center"
                    :to="{
                      name: service.routeName,
                      params: { section: rt.path },
                    }"
                    exact-active-class="nav-active"
                  >
                    <b-iconstack aria-hidden="true" font-scale="1.3">
                      <b-icon
                        stacked
                        icon="circle"
                        variant="font-grey"
                        scale="0.55"
                      ></b-icon>
                      <b-icon
                        stacked
                        icon="circle"
                        variant="extra-light"
                      ></b-icon>
                    </b-iconstack>
                    <span class="mb-0 ml-2 text-capitalize">{{ rt.name }}</span>
                  </router-link>
                </p>
              </b-collapse>
            </template>
            <template v-else>
              <router-link
                class="d-flex align-items-center pl-1 py-1 general_border_3"
                :to="{
                  name: service.routeName,
                }"
              >
                <b-icon font-scale="1.3" :icon="service.logo"></b-icon>
                <span class="mb-0 ml-2 text-capitalize">{{
                  service.name
                }}</span>
              </router-link>
            </template>
          </p>
                    <p class="pb_15 nav__item bg-white general_border_3">
            <button
              type="button"
              class="nav__accessibility-trigger d-flex align-items-center pl-1 py-1"
              @click="handleAccessibilityShortcut"
              @keydown.enter.prevent="handleAccessibilityShortcut"
              @keydown.space.prevent="handleAccessibilityShortcut"
              aria-controls="accessibility-toolbar"
              :aria-label="$t('NavigationAdmin.accessibility')"
            >
              <b-icon font-scale="1.3" icon="sliders" aria-hidden="true"></b-icon>
              <span class="mb-0 ml-2">
                {{ $t('NavigationAdmin.accessibility') }}
              </span>
            </button>
          </p>
        </b-col>

      </b-row>
    </transition-group>
    <b-modal
      id="logout-confirm"
      centered
      :title="$t('NavigationAdmin.logout_confirm_title')"
      :ok-title="$t('NavigationAdmin.logout_confirm_ok')"
      ok-variant="popup-button"
      :cancel-title="$t('annulla')"
      cancel-variant="popup-button"
      footer-border-variant="white"
      @ok="onSubmit"
      @cancel="$bvModal.hide('logout-confirm')"
    >
      <!-- <h3>Confermi di voler uscire dall'area privata?</h3> -->
    </b-modal>
  </b-container>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { requestAccessibilityToolbarFocus } from "@/_utils/accessibility";
export default {
  name: "NavigationAdmin",
  props: ["wlistener"],
  watch: {
    $route(to, from) {
      if (this.$root.isMobile) {
        this.menuVisible = false;
      }
    },
    wlistener: function () {
      this.menuIsCompact = this.$refs.navmain.clientWidth <= 80;
    },
    "$i18n.locale"() {
      this.buildActiveServices();
    },
  },
  computed: {
    welcomeName() {
      if (
        this.user &&
        this.user.anagrafica &&
        this.user.anagrafica.name &&
        this.user.anagrafica.surname
      ) {
        return (
          this.user.anagrafica.name.toLowerCase() +
          " " +
          this.user.anagrafica.surname.toLowerCase()
        );
      }
      return "Profilo";
    },
    canSeeImpostazioni() {
      if (this.user.type === 1) {
        return (
          this.user.permessi.includes("visualizzare anagrafica azienda") ||
          this.user.permessi.includes("gestire impostazioni dei servizi") ||
          this.user.permessi.includes("gestire operatori")
        );
      }
      return true;
    },
    ...mapState("utente", ["status", "user"]),
  },
  data() {
    return {
      menuVisible: true,
      positions: {
        1: "prenotazioni",
        2: "teleconsulto",
        3: "attivita",
        4: "pazienti",
        5: "agenda",
        6: "clienti",
        7: "piani asl",
      },
      activeServices: [],
      menuIsCompact: false,
    };
  },
  methods: {
    ...mapActions("utente", ["logout"]),
    onSubmit() {
      this.logout();
    },
    handleAccessibilityShortcut() {
      requestAccessibilityToolbarFocus();
    },
    toggleMenuVisibility() {
      this.menuVisible = !this.menuVisible;
    },
    toggleSubmenu(service) {
      service.submenuVisible = !service.submenuVisible;
    },
    buildActiveServices() {
      this.activeServices = [
        {
          name: this.$t("NavigationAdmin.servizi"),
          logo: "grid-3x3-gap",
          disabled: false,
          routeName: "gestione servizi",
          scope: undefined,
          submenu: false,
        },
        {
          name: this.$t("NavigationAdmin.aziende"),
          logo: "briefcase",
          disabled: false,
          routeName: "gestione aziende",
          scope: undefined,
          submenu: true,
          submenuVisible: false,
          subroutes: [
            {
              name: this.$t("NavigationAdmin.aziende_portale_concura", {
                app: this.$root.appName || "ConCura",
              }),
              path: "portale-concura",
            },
            {
              name: this.$t("NavigationAdmin.aziende_sito_pubblico"),
              path: "sito-pubblico",
            },
          ],
        },
        {
          name: this.$t("NavigationAdmin.utenti"),
          logo: "people",
          disabled: false,
          routeName: "gestione utenti",
          scope: undefined,
          submenu: false,
        },
        {
          name: this.$t("NavigationAdmin.contatti"),
          logo: "telephone",
          disabled: false,
          routeName: "contattipubblici",
          scope: undefined,
          submenu: false,
        },
        {
          name: this.$t("NavigationAdmin.registrazioni"),
          logo: "person-check",
          disabled: false,
          routeName: "registrazioniAdmin",
          scope: undefined,
          submenu: false,
        },
        {
          name: this.$t("NavigationAdmin.prenotazioni"),
          logo: "calendar2",
          disabled: false,
          routeName: "gestione prenotazioni",
          scope: undefined,
          submenu: false,
          submenuVisible: false,
        },
        {
          name: this.$t("NavigationAdmin.sottoscrizioni"),
          logo: "credit-card",
          disabled: false,
          routeName: "admin sottoscrizioni",
          scope: undefined,
          submenu: true,
          submenuVisible: false,
          subroutes: [
            {
              name: this.$t("NavigationAdmin.voucher"),
              path: "voucher",
            },
          ],
        },
        {
          name: this.$t("NavigationAdmin.pagamenti"),
          logo: "credit-card-2-front",
          disabled: false,
          routeName: "pagamenti piattaforma",
          scope: undefined,
          submenu: false,
        },
        {
          name: this.$t("NavigationAdmin.screening"),
          logo: "check2-square",
          disabled: false,
          routeName: "screening",
          scope: undefined,
          submenu: true,
          submenuVisible: false,
          subroutes: [
            {
              name: this.$t("NavigationAdmin.raccolte"),
              path: "raccolte",
            },
            {
              name: this.$t("NavigationAdmin.questionari"),
              path: "questionari",
            },
            {
              name: this.$t("NavigationAdmin.sessioni"),
              path: "sessioni",
            },
          ],
        },
        {
          name: this.$t("NavigationAdmin.piani_terapeutici"),
          logo: "box-seam",
          disabled: false,
          position_ref: 7,
          routeName: "piani asl",
          scope: undefined,
          submenu: false,
        },
        {
          name: this.$t("NavigationAdmin.alerts"),
          logo: "bell",
          disabled: false,
          routeName: "admin alerts",
          scope: undefined,
          submenu: false,
        },
        {
          name: this.$t("NavigationAdmin.logs"),
          logo: "graph-up",
          disabled: false,
          routeName: "log di sistema",
          scope: undefined,
          submenu: false,
        },
        {
          name: this.$t("NavigationAdmin.reports"),
          logo: "file-bar-graph",
          disabled: false,
          routeName: "reports metabase",
          scope: undefined,
          submenu: false,
        },
        {
          name: this.$t("NavigationAdmin.impostazioni"),
          logo: "gear",
          disabled: false,
          routeName: "impostazioni sistema",
          scope: undefined,
          submenu: false,
        },
      ];
    },
    checkPath() {
      if (this.user) {
        return "/" + this.user.i_am + "/home";
      }
    },
    handleMenuSize() {
      var navById = document.getElementsByClassName("nav-desktop")[0];
      var currentWid = navById.clientWidth;
      if (currentWid <= 80) {
        //
        navById.style.minWidth = "inherit";
        navById.style.flex = "0 0 15em";
        this.menuIsCompact = false;
      } else {
        //
        navById.style.minWidth = "0";
        navById.style.flex = "0 0 79px";
        this.menuIsCompact = true;
      }
    },
  },
  created() {
    if (this.$root.isMobile) {
      this.menuVisible = false;
    }
    this.buildActiveServices();
  },
  mounted() {
    // console.log(this.$refs.navmain.clientWidth);
    this.menuIsCompact = this.$refs.navmain.clientWidth <= 80;
  },
  updated() {},
};
</script>

<style lang="scss" scoped>
.nav__accessibility-trigger {
  background: transparent;
  border: 0;
  color: inherit;
  text-align: left;
  width: 100%;
}

.nav__accessibility-trigger:focus {
  outline: 2px solid #387db6;
  outline-offset: 2px;
}
</style>
